var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page_content"},[(_vm.component_loading)?[_c('div',{staticClass:"component_loader"},[_c('spinner',{attrs:{"status":_vm.component_loading}})],1)]:[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"}),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"float-right"},[_c('router-link',{staticClass:"site_btn btn_green",attrs:{"to":"/app/company/company-ratings"}},[_vm._v("\n            "+_vm._s(_vm.$t('company_jobs_page.backbtn'))+"\n          ")])],1)])]),_c('div',{staticClass:"m-t-20"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"textinBox"},[_c('h6',[_vm._v(_vm._s(_vm.$t('company_jobs_page.titlejob')))]),_c('h4',[_vm._v(_vm._s(_vm.current_job_details.job_title))])]),_c('ul',{staticClass:"inlineListinJobDetails"},[_c('li',[_vm._v("\n              "+_vm._s(_vm.$t('company_jobs_page.statusjob'))+"\n              "),(_vm.current_job_details.deadline > _vm.todayDate)?[(_vm.current_job_details.status === 'active')?[_c('span',{staticClass:"active"},[_vm._v(_vm._s(_vm.$t('company_jobs_page.ongoing')))])]:_vm._e(),(_vm.current_job_details.status === 'draft')?[_c('span',{staticClass:"pending"},[_vm._v(_vm._s(_vm.$t('company_jobs_page.pending')))])]:_vm._e(),(_vm.current_job_details.status === 'canceled')?[_c('span',{staticClass:"canceled"},[_vm._v(_vm._s(_vm.$t('company_jobs_page.canceled')))])]:_vm._e()]:[_c('span',{staticClass:"completed"},[_vm._v(_vm._s(_vm.$t('company_jobs_page.completed')))])]],2)])])])]),(_vm.getCandidateDetails)?[_c('user-resume',{attrs:{"job_app_id":_vm.application_id,"referenceLetter":_vm.current_referenceLetter,"coverLetter":_vm.current_coverLetter,"job_id":_vm.current_job_id,"jobseeker_id":_vm.jobseeker_id,"applied_date":_vm.applied_date}})]:_vm._e(),(!_vm.getCandidateDetails)?_c('div',{},[(_vm.rated_candidates.total != '0')?[_c('div',{staticClass:"row"},_vm._l((_vm.rated_candidates.data),function(candidate_item){return _c('div',{key:candidate_item.job_application_id,staticClass:"col-md-4"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-2"},[(
                      candidate_item.job_seeker.image_url == '' ||
                      candidate_item.job_seeker.image_url == null ||
                      candidate_item.job_seeker.image_url == undefined
                    )?[_c('img',{staticClass:"imgCandidate",attrs:{"src":"/images/user/no-image.png"}})]:[_c('img',{staticClass:"imgCandidate",attrs:{"src":_vm.SERVER_URL +
                        _vm.IMAGES_FILES +
                        candidate_item.job_seeker.image_url}})]],2),_c('div',{staticClass:"col-10"},[(
                      _vm.showDetailedRatings.includes(
                        candidate_item.job_application_id
                      )
                    )?[_c('img',{staticClass:"getDetailsIcon",attrs:{"src":"/images/hrbeeElements/companyIcons/actionsHorizontalActive.svg"},on:{"click":function($event){return _vm.hide(candidate_item.job_application_id)}}})]:[_c('img',{staticClass:"getDetailsIcon",attrs:{"src":"/images/hrbeeElements/companyIcons/actionsHorizontal.svg"},on:{"click":function($event){return _vm.getReason(candidate_item.job_application_id)}}})],_c('div',{staticClass:"textinBoxCandidateDetails"},[_c('h4',[_vm._v("\n                      "+_vm._s(candidate_item.job_seeker.name)+"\n                      "+_vm._s(candidate_item.job_seeker.surname)+"\n                    ")]),_c('p',[_vm._v("\n                      Panel Average Rating:\n                      "+_vm._s(candidate_item.interview_panel_average_ratings.rated.toFixed(
                          1
                        ))+"\n                      / 10\n                    ")])])],2)]),(
                  _vm.showDetailedRatings.includes(
                    candidate_item.job_application_id
                  )
                )?[_c('hr'),_c('div',{staticClass:"reasonForBlacklist"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('label',{staticClass:"form__label_small",attrs:{"for":"interview_category"}},[_vm._v("\n                        "+_vm._s(_vm.$t('company_jobs_page.rateeducation'))+"\n                        -\n                        "+_vm._s(candidate_item.interview_panel_average_ratings.education_rating.toFixed(
                            1
                          ))+"/10\n                      ")]),_c('div',{staticClass:"rating_item1 readonly"},[_c('ul',[_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .education_rating >= 1,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .education_rating >= 2,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .education_rating >= 3,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .education_rating >= 4,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .education_rating >= 5,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .education_rating >= 6,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .education_rating >= 7,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .education_rating >= 8,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .education_rating >= 9,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .education_rating == 10,
                            }})])]),_c('label',{staticClass:"form__label_small",attrs:{"for":"interview_category"}},[_vm._v("\n                        "+_vm._s(_vm.$t('company_jobs_page.ratelanguages'))+"\n                        -\n                        "+_vm._s(candidate_item.interview_panel_average_ratings.foreign_languages_rating.toFixed(
                            1
                          ))+"/10\n                      ")]),_c('div',{staticClass:"rating_item1 readonly"},[_c('ul',[_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .foreign_languages_rating >= 1,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .foreign_languages_rating >= 2,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .foreign_languages_rating >= 3,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .foreign_languages_rating >= 4,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .foreign_languages_rating >= 5,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .foreign_languages_rating >= 6,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .foreign_languages_rating >= 7,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .foreign_languages_rating >= 8,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .foreign_languages_rating >= 9,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .foreign_languages_rating == 10,
                            }})])]),_c('label',{staticClass:"form__label_small",attrs:{"for":"interview_category"}},[_vm._v("\n                        "+_vm._s(_vm.$t('company_jobs_page.rateexperience'))+"\n                        -\n                        "+_vm._s(candidate_item.interview_panel_average_ratings.experience_rating.toFixed(
                            1
                          ))+"/10\n                      ")]),_c('div',{staticClass:"rating_item1 readonly"},[_c('ul',[_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .experience_rating >= 1,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .experience_rating >= 2,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .experience_rating >= 3,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .experience_rating >= 4,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .experience_rating >= 5,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .experience_rating >= 6,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .experience_rating >= 7,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .experience_rating >= 8,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .experience_rating >= 9,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .experience_rating == 10,
                            }})])]),_c('label',{staticClass:"form__label_small",attrs:{"for":"interview_category"}},[_vm._v("\n                        "+_vm._s(_vm.$t('jobseeker_ratings_page.rateGeneralKnowledge'))+"\n                        -\n                        "+_vm._s(candidate_item.interview_panel_average_ratings.general_knowledge_rating.toFixed(
                            1
                          ))+"/10\n                      ")]),_c('div',{staticClass:"rating_item1 readonly"},[_c('ul',[_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .general_knowledge_rating >= 1,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .general_knowledge_rating >= 2,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .general_knowledge_rating >= 3,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .general_knowledge_rating >= 4,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .general_knowledge_rating >= 5,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .general_knowledge_rating >= 6,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .general_knowledge_rating >= 7,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .general_knowledge_rating >= 8,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .general_knowledge_rating >= 9,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .general_knowledge_rating == 10,
                            }})])]),_c('label',{staticClass:"form__label_small",attrs:{"for":"interview_category"}},[_vm._v("\n                        "+_vm._s(_vm.$t('jobseeker_ratings_page.rateKnowledgePosition'))+"\n                        -\n                        "+_vm._s(candidate_item.interview_panel_average_ratings.knowledge_about_position_rating.toFixed(
                            1
                          ))+"/10\n                      ")]),_c('div',{staticClass:"rating_item1 readonly"},[_c('ul',[_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .knowledge_about_position_rating >= 1,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .knowledge_about_position_rating >= 2,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .knowledge_about_position_rating >= 3,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .knowledge_about_position_rating >= 4,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .knowledge_about_position_rating >= 5,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .knowledge_about_position_rating >= 6,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .knowledge_about_position_rating >= 7,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .knowledge_about_position_rating >= 8,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .knowledge_about_position_rating >= 9,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .knowledge_about_position_rating == 10,
                            }})])])]),_c('div',{staticClass:"col-6"},[_c('label',{staticClass:"form__label_small",attrs:{"for":"interview_category"}},[_vm._v("\n                        "+_vm._s(_vm.$t('jobseeker_ratings_page.rateLogical'))+"\n                        -\n                        "+_vm._s(candidate_item.interview_panel_average_ratings.logical_questions_rating.toFixed(
                            1
                          ))+"/10\n                      ")]),_c('div',{staticClass:"rating_item1 readonly"},[_c('ul',[_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .logical_questions_rating >= 1,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .logical_questions_rating >= 2,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .logical_questions_rating >= 3,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .logical_questions_rating >= 4,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .logical_questions_rating >= 5,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .logical_questions_rating >= 6,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .logical_questions_rating >= 7,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .logical_questions_rating >= 8,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .logical_questions_rating >= 9,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .logical_questions_rating == 10,
                            }})])]),_c('label',{staticClass:"form__label_small",attrs:{"for":"interview_category"}},[_vm._v("\n                        "+_vm._s(_vm.$t('jobseeker_ratings_page.rateJudgement'))+"\n                        -\n                        "+_vm._s(candidate_item.interview_panel_average_ratings.judgment_capability_rating.toFixed(
                            1
                          ))+"/10\n                      ")]),_c('div',{staticClass:"rating_item1 readonly"},[_c('ul',[_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .judgment_capability_rating >= 1,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .judgment_capability_rating >= 2,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .judgment_capability_rating >= 3,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .judgment_capability_rating >= 4,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .judgment_capability_rating >= 5,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .judgment_capability_rating >= 6,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .judgment_capability_rating >= 7,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .judgment_capability_rating >= 8,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .judgment_capability_rating >= 9,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .judgment_capability_rating == 10,
                            }})])]),_c('label',{staticClass:"form__label_small",attrs:{"for":"interview_category"}},[_vm._v("\n                        "+_vm._s(_vm.$t('jobseeker_ratings_page.rateITSkills'))+"\n                        -\n                        "+_vm._s(candidate_item.interview_panel_average_ratings.it_skills_rating.toFixed(
                            1
                          ))+"/10\n                      ")]),_c('div',{staticClass:"rating_item1 readonly"},[_c('ul',[_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .it_skills_rating >= 1,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .it_skills_rating >= 2,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .it_skills_rating >= 3,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .it_skills_rating >= 4,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .it_skills_rating >= 5,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .it_skills_rating >= 6,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .it_skills_rating >= 7,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .it_skills_rating >= 8,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .it_skills_rating >= 9,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .it_skills_rating == 10,
                            }})])]),_c('label',{staticClass:"form__label_small",attrs:{"for":"interview_category"}},[_vm._v("\n                        "+_vm._s(_vm.$t('jobseeker_ratings_page.rateOtherSkills'))+"\n                        -\n                        "+_vm._s(candidate_item.interview_panel_average_ratings.other_skills_rating.toFixed(
                            1
                          ))+"/10\n                      ")]),_c('div',{staticClass:"rating_item1 readonly"},[_c('ul',[_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .other_skills_rating >= 1,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .other_skills_rating >= 2,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .other_skills_rating >= 3,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .other_skills_rating >= 4,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .other_skills_rating >= 5,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .other_skills_rating >= 6,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .other_skills_rating >= 7,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .other_skills_rating >= 8,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .other_skills_rating >= 9,
                            }}),_c('li',{class:{
                              active:
                                candidate_item.interview_panel_average_ratings
                                  .other_skills_rating == 10,
                            }})])])])]),_c('div',{staticClass:"text-center"},[_c('button',{on:{"click":function($event){return _vm.get_candidate_info(
                          candidate_item.job_seeker_id,
                          candidate_item.job_application_id,
                          candidate_item.job_seeker_apply_date,
                          candidate_item.job_seeker_cover_letter,
                          candidate_item.job_seeker_reference_letter
                        )}}},[_vm._v("\n                      "+_vm._s(_vm.$t('company_jobs_page.viewapplication'))+"\n                    ")])])])]:_vm._e()],2)])}),0)]:[_c('div',{staticClass:"box"},[_c('div',{staticClass:"text-center"},[_vm._v("\n            "+_vm._s(_vm.$t('company_jobs_page.noratedcandidate'))+"\n          ")])])]],2):_vm._e()]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }